import { PublishFormV1, PublishFormV2 } from './CreateAsset';
import CreateAsset from './CreateAsset.container';

export default CreateAsset;

export { PublishFormV1, PublishFormV2 };
